import React, { Component } from 'react';

import { withStyles } from "@material-ui/core/styles";
import { connect } from 'react-redux';
import CrudForUserDettagliModalita from './crud/DettagliModalita/CrudForUserDettagliModalita'
import { modelProps } from '../../../model/DettagliModalita';


import { styles } from '../../css/commonstyles'



class DettagliModalita extends Component {

    constructor(props) {
        super(props);

    }



    render() {

        const { classes } = this.props;

        return (
            <div className={classes.backgroundStylefafafa} >
                <div className={classes.spacingStyle3} >
                    <CrudForUserDettagliModalita
                        modelName="DettagliModalita"
                        modelNameSingolare="DettagliModalita"
                        modelProps={modelProps}
                    />
                </div>
            </div>
        );
    }
}


const mapStateToProps = (state) => {
    return {

    }

}

const mapDispatchToProps = (dispatch) => {

    return {


    }
}


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles, { withTheme: true })(DettagliModalita));